import React, { Component } from 'react'
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'
import '../../App.css'
import * as actionsCreators from  '../../store/actions/index';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../http-config';
import swal from 'sweetalert';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment, { months } from 'moment'
import { Grid } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
// import PropertyBulkUploadFile from '../../propertyBulkUpload.xlsx'
// import AreaBulkUploadFile from '../../AreaBulkUpload.xlsx'
import ReactPaginate from 'react-paginate';
import ImageUploader from 'react-images-upload';
import CancelIcon from '@material-ui/icons/Cancel';
// import { Dialog } from '@material-ui/core';
import ScheduleDialog from './ScheduleDialog'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TablePagination from '@material-ui/core/TablePagination';
import { DatePicker , MuiPickersUtilsProvider,KeyboardTimePicker,
    KeyboardDatePicker,} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { withTranslation } from 'react-i18next';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
// import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from "@material-ui/core/InputAdornment";
import MyLocationRoundedIcon from '@material-ui/icons/MyLocationRounded';

class PropertyListing extends Component {
    constructor(props){
        super(props)
        this.handleMapClick = this.handleMapClick.bind(this);
        this.state={ 
            maps_key: "AIzaSyBV5XySVlxwJm_lAJ2ZoecKismiBv1ZJAo",
            anchorEl:null,
            open:false,
            id:'',
            limit: 10,
            openDialog:false,
            propertyId:'',
            anchorEl_bulk_property             : null,
            placement_property                : '',
            open_bulk_property                : false,
            anchorEl_bulk_area             : null,
            placement_area                : '',
            open_bulk_area                : false,
            propertyType : 'all',
            filterByType:"",
            isAll:false,
            filterValue : '',
            sortObj : {
                key: '',
                value: ''
            },
            page: 0,
            controls: {
                search: {
                    value: '',
                }
            },
            deleteProperty:'',
            openPop:false,
    
            id                        :"",
            buildingName              : "",
            ownerName                 : "",
            propType                  : "",
            area                      :  "",
            wardNo                    : "",
            zone                      : "",
            ulbName                   :"",
            containmentType           : "",
            buildingNameErr           : "",
            ownerNameErr              : "",
            propTypeErr               : "",
            areaErr                   : "",
            wardNoErr                 : "",
            zoneErr                   : "",
            ulbNameErr                : "",
            containmentTypeErr        : "",
            propertyOptions           : [],
            containmentOptions        : [],
            ulbOptions                : [],
            areaOptions               : [],
            wardOptions               : [],
            onUlb                     : false,
            onUlbName                 : '',
            isDisableProperty         :  true,
            reason:'',
            reasonErr:'',
            ZoneOptions:[],
            // oneEditData:[],
            // editData:[]
            ptName:'',
            ptOwner:'',
            ptTypeId:'',
            ptArea:'' ,
            ptWard:'', 
            ptZone:'', 
            ptUlb:'',
            ptContainmentTypeId:'',
            ptUlbName:'',
            Pcomments:'',
            emergencyProperty:'',
            lastEmptiedPropertyMonth:"", 
            lastEmptiedPropertyDays:'',
            searchBy:'selectName',
            emergency:'',
            
            editId:'',
            selectDayMonth:'',
            months:'',
            days:'',
            img                    : {
                name               : "",
            },
            imgErr                 : "" ,
            isLogo                 : false      ,
            emergencyErr           :''   ,
            searchByFields          :''         ,
            phoneNumber :'' ,
            phoneNumberErr    :''  ,
            PPhoneNumber :''    ,
            selectedDate :new Date() ,
            selectDayMonthPEdit:'',
            pincode:"",
            pincodeErr:"",
            ppincode:"",
            taxAssessmentNo:"",
            houseNo:"",
            houseNoErr:"",
            taxAssessmentNoErr:"",
            usage:"",
            usageErr:"",
            locality:"",
            localityErr:"",
            ppHouseNo:"",
            ppAssessment_no:"", 
            ppUsagesType:"", 
            ppLocality:"",
            location: {
                latitude: "",
                longitude: ""
            },
            latitude: '',
            longitude: '',
            ppLongitude:"", 
            ppLatitude:"",
            usageOptions:[],
            usageOthers:"",
            optOptions:[],
            operatorName:"",
            zoom:18,
            center: {
                lat: "",
                lng:""
            },
        }
    }

    
    componentDidMount() {
        const success = position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const  center = {
            lat : latitude,
            lng: longitude
            }
            this.setState({
              latitude: latitude,
              longitude: longitude,
              center:center
            });
          };
        
          const error = () => {
            // this.setState({optOptions
            //     latitude:  17.123184,
            //     longitude: 79.208824,
            //     center: {
            //         lat: 17.123184,
            //         lng: 79.208824
            //     }
            //   });
         
            console.log("Unable to retrieve your location");
          };
        
          navigator.geolocation.getCurrentPosition(success, error);
        axios({
            method  : 'get',
            url     : '/load_template/master_data',
            headers : {'Authorization': `Bearer ${this.props.token}`}
        })
        .then((response) => {
            this.setState({ propertyOptions : response.data.data['master-data'][1].data,
                            //ulbOptions : response.data.data['master-data'][3].data,
                            // wardOptions : response.data.data['master-data'][3].data.find(data=>data.id==this.state.ulbName).children ?
                            // response.data.data['master-data'][3].data.find(data=>data.id==this.state.ulbName).children[0].data : [{id: -1, name: "Ward doesn't exists"}],
                            // areaOptions : response.data.data['master-data'][4].data.find(data=>data.id==this.state.ulbName).children ?
                            // response.data.data['master-data'][4].data.find(data=>data.id==this.state.ulbName).children[0].data : [],
                            containmentOptions : response.data.data['master-data'][5].data
                        })
        })
        //changing the url to get all ulbs in dropdown, earlier it was from master-data
        axios({
            method : 'get',
            url : '/auth/getAllUlb'
        })
        .then((response) => {
            const newArr1 = []
            newArr1.push(response.data.data.filter((option) => option.Code !== null))
            const newArr2 = []
            newArr2.push(response.data.data.filter((option) => option.Code == null))
            const newArr3 = newArr1[0].concat(newArr2[0])
            this.setState({ulbOptions : newArr3}) 
        })

        axios({
            method: 'get',
            url: '/auth/usageType',
        })
            .then((response) => {
                this.setState({
                    usageOptions: response.data.data.usageType
                })
            })

            // axios({
            //     method: 'get',
            //     url: '/auth/dropDown',
    
            // })
            //     .then((response) => {
            //         this.setState({
            //             optOptions: response.data.data.operators
            //         })
            //     })
                
        let payload = {
            token: this.props.token,
            page:  this.state.page,
            limit: this.state.limit,
            propertyTypeId: this.state.filterValue,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value,
            searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
        }
        this.props.onFetchPropertyHeaders(payload);
        this.props.onFetchPropertyListing(payload)
        this.props.onPropertyType()
    }



    handleChange = (event) =>{
        if(event.target.name=="wardNo"){
            let payload={
                token:this.props.token
            }
            axios({
                method  : 'get',
                url     : `ward/${event.target.value}`,
                headers : {'Authorization': `Bearer ${payload.token}`}
            })
            .then((res)=>{
                this.setState({ZoneOptions: res.data.data.wards})
            })
            .catch((err)=>{
                console.log(err)
            })
        }


        if(event.target.name=="ulbName"){
            this.setState({[event.target.name]:event.target.value})
            this.state.ulbName=event.target.value
            let payload={
                token:this.props.token
            }
            axios({
                method  : 'get',
                url     : '/load_template/master_data',
                headers: {'Authorization': `Bearer ${payload.token}`}
            })
        //     .then((response) => {
        //         this.setState({
        //              wardOptions : response.data.data['master-data'][3].data.find(data=>data.id==this.state.ulbName).children ?
        //              response.data.data['master-data'][3].data.find(data=>data.id==this.state.ulbName).children[0].data : [{id: -1, name: "Ward doesn't exists"}],
                            
                     
        //              areaOptions : response.data.data['master-data'][4].data.find(data=>data.id==this.state.ulbName).children ?
        //                      response.data.data['master-data'][4].data.find(data=>data.id==this.state.ulbName).children[0].data : [],
                             
                            
        //     })
        // })
    }else{
        
        if(event.target.name == "usage"&& event.target.value != "Others"){
            this.setState({usageOthers:""})
        }
        if(event.target.name == "days"){
            this.setState({months : "" })
        }
        else if (event.target.name == "months"){
            this.setState({days : ""})
        }
     
    
    }    
    this.setState({[event.target.name]:event.target.value},() => {
        this.checkValidity()
    })   
    }
    handlePageClick = (e) => {
        const selectedPage = e.selected;
        this.setState({page: selectedPage + 1})
        let payload = {
            token: this.props.token,
            page:  selectedPage + 1,
            limit: this.state.limit,
            propertyTypeId: this.state.filterValue,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value,
            searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
        }
        this.props.onFetchPropertyListing(payload)
    };

    handleClickMoreVertIcon=(event,propertyId, deleteProperty, ptName,ptOwner, ptTypeId, ptArea , ptWard, ptZone, ptUlb, ptContainmentTypeId, pulbName, Pcomments, emergencyProperty,  lastEmptiedPropertyMonth, lastEmptiedPropertyDays, PPhoneNumber,  selectDayMonthPEdit, ppincode,  ppHouseNo, ppAssessment_no, ppUsagesType, ppLocality, ppLongitude, ppLatitude)=>{
        this.setState({open:!this.state.open,anchorEl:event.currentTarget,propertyId, deleteProperty, ptName,ptOwner, ptTypeId, ptArea , ptWard, ptZone, ptUlb, ptContainmentTypeId, pulbName, Pcomments, emergencyProperty,  lastEmptiedPropertyMonth, lastEmptiedPropertyDays, PPhoneNumber, selectDayMonthPEdit, ppincode,  ppHouseNo, ppAssessment_no, ppUsagesType, ppLocality, ppLongitude, ppLatitude})
      }
    handleClickAwayEdit = () => {
    this.setState({open:false});
    };
    
    /*Property Bulk upload*/
    handleClickProperty = (newPlacement) => (event) => {
        this.setState({ anchorEl_bulk_property:event.currentTarget, placement_property:newPlacement, open_bulk_property:!this.state.open_bulk_property});
    };
    handleClickAwayBulkProperty = () => {
        this.setState({open_bulk_property: false});
    };
    onFileUploadProperty = () => { 
        let props= this.props
        const payload = {
            token : this.props.token
        }
        const formData = new FormData(); 
        formData.append( 
            "PropertyBulkUploadFile", 
            this.state.selectedFile, 
            this.state.selectedFile.name 
        )
        this.props.onFetchPropertyBulkImport(payload,formData,props);
        this.setState({open_bulk_property:false})
    }

    onFileChangeProperty = (event) => {
        this.setState({ selectedFile: event.target.files[0]},()=>{
            this.onFileUploadProperty()
        });   
    }

    handleCloseProperty = (event) => {
        this.setState({open_bulk_property:false})
    };
    
    /*Area Bulk Upload*/
    handleClickArea = (newPlacement) => (event) => {
        this.setState({ anchorEl_bulk_area:event.currentTarget, placement_area:newPlacement, open_bulk_area:!this.state.open_bulk_area});
    };
    handleClickAwayBulkArea = () => {
        this.setState({open_bulk_area: false});
    };
    // onFileUploadArea = () => { 
    //     let props= this.props
    //     const payload = {
    //         token : this.props.token
    //     }
    //     const formData = new FormData(); 
    //     formData.append( 
    //         // "AreaBulkUploadFile", 
    //         this.state.selectedFile, 
    //         this.state.selectedFile.name 
    //     )
    //     this.props.onFetchAreaBulkImport(payload,formData,props);
    //     this.setState({open_bulk_area:false})
    // }

    // onFileChangeArea = (event) => {
    //     this.setState({ selectedFile: event.target.files[0]},()=>{
    //         this.onFileUploadArea()
    //     });   
    // }

    handleCloseArea = (event) => {
        this.setState({open_bulk_area:false})
    };
    
    openDialog = () => {
        this.setState({
            openDialog:true
        })
    }

    handleDialogClose = (value) => {
        this.setState({
            openDialog:value
        }) 
    }
    onClickGetFilterVals = (e, colObj) => { 
        this.setState({filterValue: e})
    let payload = {
        token: this.props.token,
        page:  this.state.page,
        limit: this.state.limit,
        propertyTypeId: e,
        sortName:this.state.sortObj.key,
        sortValue :this.state.sortObj.value,
        searchQuery: this.state.controls.search.value,
        searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
    }
    this.props.onFetchPropertyListing(payload)
    }         
    handleSort = (e,sortBy) => {
        let sortObj
        if (this.state.sortObj.key === sortBy.accessor) {
            let value = (this.state.sortObj.value === 'DESC') ? 'ASC' : 'DESC';
            sortObj = {
                key : sortBy.accessor,
                value: value
            }
        } 
        else {
            sortObj = {
                key : sortBy.accessor,
                value: 'DESC'
         }    
         }
 
        this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
        let payload = {
            token: this.props.token,
            sortName:sortObj.key,
            sortValue : sortObj.value,
            page:  this.state.page,
            limit: this.state.limit,
            propertyTypeId: this.state.filterValue,
            searchQuery: this.state.controls.search.value,
            searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
        }
   
        this.props.onFetchPropertyListing(payload) 
  
      }
      handlePropertySearch = (e) => {
        e.preventDefault()
        let searchVal = this.state.controls.search.value
        if (!!searchVal && searchVal.length >= 2 ||this.state.selectedDate !=null ) {
            let payload = {
                token: this.props.token,
                searchQuery:searchVal,
                limit:10,
                searchByFields : this.state.searchBy,
                page:this.state.page,
                searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
                propertyTypeId: this.state.filterValue,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
              
            }
            this.props.onSearchProperty(payload, '', '') 
        } else {
         
            swal("Enter atleast 2 characters")
        }
    }
    inputChangedHadler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
            }
        }
        this.setState({ controls: updatedControls });
        if( updatedControls.search.value === ''){
            let payload = {
                token: this.props.token,
                searchQuery:'',
                searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
                limit:this.state.limit,
                page:this.state.page,
                searchByFields : this.state.searchBy,
                propertyTypeId: this.state.filterValue,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
            }
            
            this.props.onSearchProperty(payload, '', '') 
        } 
    }

    handleExport = () => {
        let payload = {
            token: this.props.token,
      
        }
        this.props.exportProperty(payload)
    }
    handleDelete =(id, t)=>{
        let payload = {
            propertyId: id,
            token: this.props.token,
            page:  this.state.page,
            limit: this.state.limit,
            propertyTypeId: this.state.filterValue,
            sortName:this.state.sortObj.key,
            sortValue :this.state.sortObj.value,
            searchQuery: this.state.controls.search.value,
            searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
        }
        this.props.onDeleteProperty(payload, t)

    }  
    openSignlePropertyPop=()=>{
        const success = position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const  center = {
            lat : latitude,
            lng: longitude
            }

            this.setState({
              latitude: latitude,
              longitude: longitude,
              center:center,
              zoom:18
            });
          };
        
          const error = () => {
            console.log("Unable to retrieve your location");
          };
      navigator.permissions.query({name: 'geolocation'}).then(permission =>{
        if(  permission.state === "granted"){
            navigator.geolocation.getCurrentPosition(success, error);

        }
        else if(permission.state === "prompt"){
            const tsCenter = {
                lat:17.8302,
                lng:79.2778
            }
            this.setState({
                latitude: 17.8302,
                longitude: 79.2778,
                center:tsCenter,
                zoom:7
              });
        }
        else if(permission.state === "denied"){
            const tsCenter = {
                lat:17.8302,
                lng:79.2778
            }
            this.setState({
                latitude: 17.8302,
                longitude: 79.2778,
                center:tsCenter,
                zoom:7
              });
        }

      })
      
        this.setState({
            openPop:true,
            buildingName              :"" ,
            ownerName                 : "",
            propType                  : "",
            wardNo                    : "",
            zone                      : "",
            ulbName                   : "",
            containmentType            :"",
            containmentTypeErr          : '',
            emergency                  :"",
            selectDayMonth             : "",
            reason                     : "",
            days                       : "",
            months                     : "",
            buildingNameErr           : "",
            ownerNameErr              : "",
            propTypeErr               : "",
            wardNoErr                 : "",
            zoneErr                   : "",
            ulbNameErr                : "",
            emergencyErr               :'',
            phoneNumberErr:'',
            editId:'',
            pincode:"",
            pincodeErr:"",
            ppincode:"",
            houseNo                   :"", 
            taxAssessmentNo           :"",
            locality                  :"",
            usage                     :"",
            usageOthers:"",
          
        })
    }
    handleClosePop =()=>{
        this.setState({
            openPop:false,
            editId:'',
            editData:[],
            buildingNameErr           : "",
            ownerNameErr              : "",
            propTypeErr               : "",
            wardNoErr                 : "",
            zoneErr                   : "",
            ulbNameErr                : "",
            emergencyErr               :'',
            containmentType            :"",
            containmentTypeErr:'',
            phoneNumberErr :'',
            phoneNumber :'' ,
            buildingName              :"" ,
            ownerName                 : "",
            propType                  : "",
            wardNo                    : "",
            zone                      : "",
            ulbName                   : "",
            // containmentTypeErr           : '',
            emergency                  :"",
            selectDayMonth             : "",
            reason                     : "",
            pincode:"",
            pincodeErr:"",
            ppincode:"",
            houseNo                   :"", 
            taxAssessmentNo             : "",
            locality                  :"",
            usage                      :"",
            longitude                 :"",
            latitude                  :"",
            usageOthers:"",
            center:{
                lat:"",
                lng:""
            }
        })
    }
    handleSubmit = (e) =>{
        const {t, i18n} = this.props
        let props=this.props
      const err = this.checkValidity()

      if(!err){
        if(this.state.editId != ""){
        const formdata = new FormData()
        formdata.append("token" ,this.props.token)
        formdata.append("id" , this.state.editId)
        formdata.append("Name" ,this.state.buildingName)
        formdata.append("OwnerName" , this.state.ownerName)
        formdata.append("PropertyTypeId", this.state.propType)
        formdata.append("ContainmentTypeId" , this.state.containmentType)
        formdata.append("Zone" , this.state.zone)
        formdata.append("Ward" , this.state.wardNo)
        formdata.append("LastEmptiedDays" , this.state.days)
        formdata.append("LastEmptiedMonths" , this.state.months)
        formdata.append("Emergency", this.state.emergency)
        formdata.append("Comments" , this.state.reason)
        formdata.append("Photo" , this.state.img['name'])
        formdata.append("PhoneNumber" , this.state.phoneNumber)
        formdata.append("ULBId", this.state.ulbName)
        formdata.append("PinCode", this.state.pincode)//sending data to API

        formdata.append("UsageId",!!this.state.usage&& this.state.usage == "Others" ? this.state.usageOthers:this.state.usage)//sending data to api
        formdata.append("ASSESSMENT_NO", this.state.taxAssessmentNo)//sending data to api
        formdata.append("OWNER_DOORNO", this.state.houseNo)//sending data to api
        formdata.append("Latitude", this.state.latitude)//sending data to api
        formdata.append("Longitude", this.state.longitude)//sending data to api
        formdata.append("Locality", this.state.locality)//sending data to api
        this.props.onEditPropertyData(formdata, t)
        this.handleClosePop()
        }
        else{
        const formdata = new FormData()
        formdata.append("token" ,this.props.token)
        formdata.append("Name" ,this.state.buildingName)
        formdata.append("OwnerName" , this.state.ownerName)
        formdata.append("PropertyTypeId", this.state.propType)
        formdata.append("ContainmentTypeId" , this.state.containmentType)
        formdata.append("Zone" , this.state.zone)
        formdata.append("Ward" , this.state.wardNo)
        formdata.append("LastEmptiedDays" , this.state.days)
        formdata.append("LastEmptiedMonths" , this.state.months)
        formdata.append("Emergency", this.state.emergency)
        formdata.append("Comments" , this.state.reason)
        formdata.append("Photo" , this.state.img['name'])
        formdata.append("PhoneNumber" , this.state.phoneNumber)
        formdata.append("ULBId", this.state.ulbName)
        formdata.append("PinCode", this.state.pincode)//sending data to API

        formdata.append("UsageId",!!this.state.usage&& this.state.usage == "Others" ? this.state.usageOthers:this.state.usage)//sending data to api
        formdata.append("ASSESSMENT_NO", this.state.taxAssessmentNo)//sending data to api
        formdata.append("OWNER_DOORNO", this.state.houseNo)//sending data to api
        formdata.append("Latitude", this.state.latitude)//sending data to api
        formdata.append("Longitude", this.state.longitude)//sending data to api
        formdata.append("Locality", this.state.locality)//sending data to api
        this.props.OnAddPropertySingle(formdata, t)
        this.handleClosePop()    
        }
    }else{
        swal({icon:"error",title:"Kindly fill all required fields!!"})
    }
}
    
    
    handleopeneditProperty =(pId,ptName,ptOwner, ptTypeId, ptArea , ptWard, ptZone, ptUlb, ptContainmentTypeId, ptUlbName, pcomments, emergencyProperty,  lastEmptiedPropertyMonth, lastEmptiedPropertyDays, PPhoneNumber , selectedDayMonthEdit, pincodeEdit,
        ppHouseNoEdit,
        ppAssessment_noEdit,
        ppUsagesType,
        ppLocalityEdit,
        ppLongitudeEdit, 
        ppLatitudeEdit)=>{

        this.setState({
            openPop:true,
            // editData:data,
            buildingName              :ptName ,
            ownerName                 :ptOwner,
            propType                  :ptTypeId,
            area                      :ptArea,
            wardNo                    :ptWard,
            zone                      :ptZone,
            ulbName                   :ptUlb,
            containmentType           :ptContainmentTypeId,
            editId                    :pId,
            emergency                 :emergencyProperty,
            // selectDayMonth             : lastEmptiedProperty,
            reason                    :pcomments,
            phoneNumber               :PPhoneNumber,
            selectDayMonth            :selectedDayMonthEdit,
            months                    :lastEmptiedPropertyMonth,
            days                      :lastEmptiedPropertyDays,
            pincode                   :pincodeEdit , // prefield pincode data for edit property.
            houseNo                   :ppHouseNoEdit, 
            taxAssessmentNo           :ppAssessment_noEdit,
            locality                  :ppLocalityEdit,
            usage                    :ppUsagesType,
            longitude                 :ppLongitudeEdit,
            latitude                  :ppLatitudeEdit,
            center: {
                lat:Number(ppLatitudeEdit) ,
                lng:Number(ppLongitudeEdit)
            },
            zoom:18
        })
    }
    handleChangeSearch=(e)=>{
        if(e.target.value == 'selectName'){
            let payload = {
                token: this.props.token,
                page:  this.state.page,
                limit: this.state.limit,
                propertyTypeId: this.state.filterValue,
                sortName:this.state.sortObj.key,
                sortValue :this.state.sortObj.value,
                searchQuery: this.state.controls.search.value,
                searchDate:moment(this.state.selectedDate).format('DD-MMM-yyyy'),
            }
            this.props.onFetchPropertyListing(payload)
        }
        if(e.target.value == 'updated'){
            this.setState({selectedDate: new Date()})
        }
        if(e.target.value == 'created'){
            this.setState({selectedDate: new Date()})
        }
        this.setState({searchBy:e.target.value, searchByFields:e.target.name })
    }


    handleImage = (e) => {
        this.setState({img:e[0],isLogo:true},
        //      ()=>
        //  this.checkValidity()
        )
    }
    checkValidity =()=>{
        const {t, i18n} = this.props
        let isError = false
        
        if(!this.state.containmentType){
            isError=true
            this.setState({containmentTypeErr : `${t("required")}`})
        }
        else{
            // isError=false
            this.setState({containmentTypeErr:''})
        }
        if(!this.state.ulbName){
            isError=true
            this.setState({ulbNameErr : `${t("required")}`})
        }
        else{
            // isError=false
            this.setState({ulbNameErr:''})
        }
        if(!this.state.ownerName){
            isError=true
            this.setState({ownerNameErr:`${t("required")}`})
        }
        else{
            // isError=false
            this.setState({ownerNameErr:''})
        }
        if(!this.state.propType){
            isError=true
            this.setState({propTypeErr:`${t("required")}`})
        }
        else{
            // isError=false
            this.setState({propTypeErr:''})
        }
  
      
        if(!this.state.buildingName){
            isError=true
            this.setState({buildingNameErr : `${t("required")}`})
        }
        else{
            // isError=false
            this.setState({buildingNameErr:''})
        }
       
       if(!this.state.phoneNumber){
            isError=true
            this.setState({phoneNumberErr : `${t("required")}`})
        }
        else if(this.state.phoneNumber){
            if(!this.state.phoneNumber.match(/^[0-9]{10,10}$/)){
                isError=true
                this.setState({phoneNumberErr: `${t("operatorContact")}`})
            }
            
            else{
                if(this.state.phoneNumber.length === 10){
                    isError=false
                    this.setState({phoneNumberErr:''})
                }
              
            }
     
        }else{
                this.setState({phoneNumberErr:''})
            }
     // added validation for if zones no. are unknown and you have ward no.
        if(this.state.wardNo !=""){
            if(this.state.zone !=""){
                isError=false
                this.setState({zoneErr: ""})
            }else{
                isError=true
                this.setState({zoneErr:`${t('Kindly enter "NA" if you are unknown to zone no.')}`})
            }
           
        }
        else{
            isError=true
            this.setState({zoneErr: `${t("required")}`})
        } 
          // added validation for if zones no. are unknown and you have ward no.
          if(this.state.zone !=""){
            if(this.state.wardNo !=""){
                isError=false
                this.setState({wardNoErr: ""})
            }else{
                isError=true
                this.setState({wardNoErr:`${t('Kindly enter "NA" if you are unknown to ward no.')}`})
            }
           
        }
        else{
            isError=true
            this.setState({wardNoErr:`${t("required")}`})
        }     
// validation for pincode field.
     if(this.state.pincode){
            if(!this.state.pincode.match(/^[0-9]{6,6}$/)){
                isError=true
                this.setState({pincodeErr: `${t("pincodeErrValid")}`})
            }
            else{
                if(this.state.pincode.length === 6){
                    isError=false
                    this.setState({pincodeErr:''})
                }
              
            }
     
        }else{
                this.setState({pincodeErr:''})
            }

        return isError
    }
    handleRemove=()=>{
        this.setState({img :{name :''},isLogo:false})
       }

       handleDateChange = (date) => {
        this.setState ({
          selectedDate:date
        })
      }

      handleChangePage = (event, newPage) => {
        this.setState({page:newPage})
      };
      handleChangeRowsPerPage = (event) => {
        this.setState({limit:parseInt(event.target.value, 10),page:0});
        
      };
      static defaultProps = {
        center: {
            lat: 17.123184,
            lng: 79.208824
        },
        zoom: 7,
        maps_key: "AIzaSyBV5XySVlxwJm_lAJ2ZoecKismiBv1ZJAo"
    };
      handleMapClick(x) {
        this.setState({ latitude: x.lat }, () => {
            this.checkValidity()
        })
        this.setState({ longitude: x.lng })
    }
    handleMap = (value) => {
        if (document.fullscreenElement) {
            this.setState({ position: 'fixed', top: 0, left: 0 })
            const screenClass =  document.getElementsByClassName("current-loct")
            for (let index = 0; index < screenClass.length; index++) {
                const element = screenClass[index];
                element.style["left"] ="709px"; 
                element.style.top="285px";
}
        }
        else {
            this.setState({ position: 'inherit', top: '50%', left: '50%' })
            const screenDeClass =  document.getElementsByClassName("current-loct")
            for (let index = 0; index < screenDeClass.length; index++) {
            const elementOff = screenDeClass[index];
            elementOff.style["left"] ="363px"; 
            elementOff.style.top="unset";
            
        }
        }
    }

    getCurrentLocation =()=>{
        const success = position => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const  center = {
            lat : latitude,
            lng: longitude
            }

            this.setState({
                latitude: latitude,
                longitude: longitude,
                center:center,
                zoom:18
            });
          };
        
          const error = () => {
                swal({
                    icon:'warning',
                    title:"Browser location is blocked",
                    text:"Kindly unlocked the location from setting."
                })
          };
      navigator.permissions.query({name: 'geolocation'}).then(permission =>{
        if(  permission.state === "granted"){
            navigator.geolocation.getCurrentPosition(success, error);
        }
        else if(permission.state === "prompt"){
            navigator.geolocation.getCurrentPosition(success, error);
        }
        else if(permission.state === "denied"){
            navigator.geolocation.getCurrentPosition(success, error);
        }

      })
    }
    render() {
        const {t, i18n} = this.props
        let updatedHeaders = this.props.headers
        let filterValue
        const propertTypeLists = this.props.Type
        const selectData = !!propertTypeLists&&propertTypeLists.map((item,i)=>{
              return  <option key={i} value={item.Id}>
                    {item.Name}
                </option>
                
        })
        const headers =  !!updatedHeaders&&updatedHeaders.map(header => {
            if(header.accessor=='actionButton'){
                header.header = 'Action'
            } 
            if(header.accessor == "propertyType"){
                header.header = 'Property Type'
                header.filter = true
            }
            // if(header.header === 'Owner' ||  header.header === 'Containment Type' ){
            //     header.header = ''
            // }
            let filterType
            if(header.filter == true){
                filterType = 
                <select 
                style={{
                    width: '16px',
                    borderColor:"white",
                    backgroundColor: 'LightGray',
                    outline:"none",
                    display: "flex",
                    alignItems: 'right',   
                  }}
                value={filterValue}
                onChange={(e) => {
                    this.onClickGetFilterVals(e.target.value, header)
                }}
                >
                    <option value="">All</option>
                    {selectData}
                </select>
            }
          {
                return <TableCell key={header.header} className={"white-space"}>
                             <div style={header.accessor == "name"?{
                                    display: 'flex',
                                    alignItems: 'start',
                                    whiteSpace: 'break-spaces',
                                    height:'3em',
                                    width: "120px",
                                    marginRight:'25px'
                                    }: {
                                    display: 'flex',
                                    alignItems: 'start',
                                    // whiteSpace: 'break-spaces',
                                    height:'3em',
                                    width: "150px"
                                    }}>
                             {filterType}
                             {header.header}
                            <div onClick={(e) =>  this.handleSort(e,header)}>
                        {header.header == "Property Type" || header.header == 'Action' ?'':    <div>{
                             this.state.currentSortId===header.accessor? this.state.sortObj.value ==='ASC'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                           }
                           </div> }   
                        </div>
                                        
                        
                            </div>
                        </TableCell>
            }
        }
        );
        
        const properties=!!this.props.propertyListing&&this.props.propertyListing.slice(this.state.page * this.state.limit, this.state.page * this.state.limit + this.state.limit).map((property, j) =>   {
        const propertyId=property["propertyId"]
        const deleteProperty =property['isDeleteAbleProperty']
        const pName = property.name
        const pOwner =  property.ownerName 
        const pTypeId = property.propertyTypeId
        const pArea = property.areaId   
        const pWard = property.ward  
        const pZone = property.zone   
        const pUlb = property.ulbId  
        const pulbName = property.ulbName
        const pContainmentTypeId  = property.containmentTypeId
        const Pcomments = property.comments
        const emergencyProperty =property.emergencData
        const lastEmptiedPropertyMonth =property.lastEmptiedMonths
        const createdByP = property.createdBby
        const lastEmptiedPropertyDays =property.lastEmptiedDays
        const  PPhoneNumber = property.phoneNumber
        const selectDayMonthP = (property.lastEmptiedMonths != "null" && property.lastEmptiedMonths != null) ? "M": (property.lastEmptiedDays != "null" && property.lastEmptiedDays != null) ? "D" : ""
        const ppincode = property.pinCode //getting pincode data
        const  ppHouseNo = property.ownerDoorNo
        const  ppAssessment_no = property.assessment_no
        const  ppUsagesType = property.usagesType
        const  ppLocality = property.locality
        const ppLongitude = property.longitude
        const ppLatitude= property.latitude
            return <TableRow style={{
            whiteSpace: 'normal',
            wordWrap: 'break-word'
        }} key={j}>{
                !!updatedHeaders&&updatedHeaders.map((header, i)=>{
                       if(header.accessor=='actionButton'){
                        return  <TableCell  key={i}>
                                            <IconButton
                                            aria-label="more"
                                            aria-controls="long-menu"
                                            aria-haspopup="true"
                                            onClick={(e)=>this.handleClickMoreVertIcon(e,propertyId, deleteProperty,pName,pOwner, pTypeId, pArea , pWard, pZone, pUlb, 
                                                pContainmentTypeId, pulbName, Pcomments, emergencyProperty, 
                                                lastEmptiedPropertyMonth, lastEmptiedPropertyDays, PPhoneNumber, selectDayMonthP, ppincode, 
                                                ppHouseNo, ppAssessment_no, ppUsagesType, ppLocality, ppLongitude, ppLatitude)}
                                            >
                                            <MoreVertIcon fontSize='small'/>
                                            </IconButton>
                                                <Popper
                                                open={this.state.open} anchorEl={this.state.anchorEl}>
                                                 <ClickAwayListener onClickAway={this.handleClickAwayEdit}>
                                                <Paper style={{boxShadow:"none", border:"1px solid #3dab35"}}>
                                                    <MenuList>
                                                 <MenuItem  className='email_link' style={{color:'green'}} onClick={()=>this.handleopeneditProperty(
                                                     this.state.propertyId,
                                                    this.state.ptName,
                                                    this.state.ptOwner,
                                                    this.state.ptTypeId, 
                                                    this.state.ptArea, 
                                                    this.state.ptWard,
                                                    this.state.ptZone,
                                                    this.state.ptUlb ,
                                                    this.state.ptContainmentTypeId,
                                                    this.state.ptUlbName, 
                                                    this.state.Pcomments, 
                                                    this.state.emergencyProperty, 
                                                    this.state.lastEmptiedPropertyMonth, 
                                                    this.state.lastEmptiedPropertyDays,
                                                    this.state.PPhoneNumber,  
                                                    this.state.selectDayMonthPEdit, 
                                                    this.state.ppincode,
                                                    this.state.ppHouseNo,
                                                    this.state.ppAssessment_no,
                                                    this.state.ppUsagesType,
                                                    this.state.ppLocality,
                                                    this.state.ppLongitude, 
                                                    this.state.ppLatitude)}>{t("edit")}</MenuItem>



                                                    </MenuList>
                                                    <MenuList>
                                                    <Link to={`./property_loads/${this.state.propertyId}`} className='email_link'> <MenuItem>{t("loads")}</MenuItem></Link>

                                                
                                                    </MenuList>
                                                    {/* {
                                                        this.state.deleteProperty === true?  */}
                                                        <MenuList>
                                                         <MenuItem  className='email_link' style={{color:'green'}} onClick = { () => {
                                                        swal({ title   :  `${t("ulbDeleteErr1")}`,
                                                            text    : `${t("ulbDeleteErr2")}`,
                                                            icon    : "warning",
                                                            buttons : {
                                                            cancel  : `${t("ulbDeleteErr4")}`,
                                                            confirm : `${t("ulbDeleteErr3")}`}
                                                        })
                                                        .then((willDelete) => {
                                                            if (willDelete) {
                                                                this.handleDelete(this.state.propertyId, t) 
                                                            } 
                                                        });
                                                    }}>{t("delete")}</MenuItem>
                                                        </MenuList>
                                                        {/* :''
                                                    } */}


                                                    
                                                </Paper>
                                                </ClickAwayListener>
                                            </Popper>
                                </TableCell>
                       }
                       else if(header.accessor=='updatedAt' || header.accessor== 'createdAt'){
                           return <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i} >{ moment(property[header.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                       }

                       else if(header.accessor=='lastDesludgeDate'){
                        return <TableCell  style={{
                         whiteSpace: "normal",
                         wordWrap: "break-word"
                       }} key={i}>{ property[header.accessor] && moment(property[header.accessor]).format('DD-MMM-YYYY')}</TableCell>
                    }
                    else if(header.header == 'Scheduled AT'){
                        return <TableCell  style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i}>{ property.scheduleId ? property[header.accessor] && moment(property[header.accessor]).format('DD-MMM-YYYY') : 'NA'}</TableCell>
                    }
                    else if (header.accessor == 'photo') {
                        if (property[header.accessor] != "null" && property[header.accessor] != undefined) {
                            return <TableCell> <a className="email_link" href={property[header.accessor]} target="_blank">View</a></TableCell>
                        }
                        else {
                            return <TableCell></TableCell>
                        }
                    }
                     
                       else{
                           return  <TableCell style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word"
                          }} key={i} className={"white-space"}>{property[header.accessor] == null || property[header.accessor] == 'null'  ? ' ' : property[header.accessor]}</TableCell>
                       }
                       




                }) 
            }
            </TableRow>

    })
        return (
            <div>
                <div className="dashboard_right_content">
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                        <div className="dashboard_right_content_top">
                            <h5>{t("propertyMangHeading")}</h5>
                            <div className="dashboard_right_content_top_options">
                            <div>
                        <FormControl>
                            <Select value={this.state.searchBy}
                                onChange={this.handleChangeSearch}
                                name="searchBy"
                                style={{ width: '100%' ,  border:"1px solid #ccc", borderRadius:'5px'}}>
                                 <MenuItem value={"selectName"}>{`${t("selectName")}`}</MenuItem>
                                    <MenuItem value={"name"}>{`${t("byPropName")}`}</MenuItem>
                                    {/* <MenuItem disabled  value={"created"}>{"By Created Date"}</MenuItem>
                                    <MenuItem disabled  value={"updated"}>{"By Updated Date"}</MenuItem> */}
                                
                            </Select>
                             </FormControl>
                      </div>
                            <div className="dashboard_right_content_top_search">
                                {/* {
                                    this.state.searchBy === "name" ||  this.state.searchBy  === "selectName" ? */}
                                    
                                    <Paper component="form">
                                        { this.state.searchBy === "name" ||  this.state.searchBy  === "selectName" ?
                                        <>
                                           <IconButton aria-label="menu" disabled={this.state.searchBy == "selectName"? true:false}>
                                         <img src="images/search_icon.svg" />
                                     </IconButton>
                                     <InputBase disabled={this.state.searchBy == "selectName"? true:false} onChange={(event) => this.inputChangedHadler(event, 'search')} placeholder={this.state.searchBy== "created"?"Created Date":this.state.searchBy== "updated"?"Updated Date":  this.state.searchBy == "selectName" ? "" : `${t("propName")}`} />
                                        </>
                                      
                                     :
                                     
                                     <div className='property-date'>

                                     <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                     <KeyboardDatePicker
                                     format="dd-MMM-yyyy"
                                     margin="normal"
                                    //  minDate={ moment(new Date().add(30, 'd'))}
                                     // disabled={this.state.emergency}
                                     id="date-picker-inline-property"
                                     disableFuture
                                     // label="Select Date"
                                     value={this.state.selectedDate}
                                     onChange={this.handleDateChange}
                                     className="quick-reg-datepicker"
                                     KeyboardButtonProps={{
                                     'aria-label': 'change date',
                                     }}
                                     />  
                                     </MuiPickersUtilsProvider>
 
                                     </div>
                                     }
                                   
                                    <Button onClick={this.handlePropertySearch} variant="contained" color="primary" type="submit" disabled={this.state.searchBy == "selectName"? true:false}>{t("search")}</Button>
                                </Paper>

                                 
                                {/* } */}
                               




                                
                            </div>
                            <div>
                            <Button style={{width:'100%', marginLeft:'10px' }} onClick={this.handleExport}>{t("export")}</Button>
                            </div>
                                <Button className="email_link"
                                ref={this.state.anchorRef}
                                aria-controls={this.state.open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={this.handleClickProperty('bottom')}
                                style={{height:'35px', marginLeft:'20px'}}>
                                {t("bulkImport")}
                                {
                                    this.state.open ?   <ArrowDropUpIcon /> : <ArrowDropDownIcon/> 
                                }
                                
                            </Button>
                            <Popper style={{zIndex:"10"}} open={this.state.open_bulk_property} anchorEl={this.state.anchorEl_bulk_property} placement={this.state.placement_property} transition>
                            {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={this.handleClickAwayBulkProperty}>
                                <Paper style={{zIndex: 1, border:"1px solid #3dab35"}}>
                                    <MenuList>
                                    <MenuItem  style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}} onClick={()=>this.openSignlePropertyPop()}> 
                                        
                                            {t("singleProp")}
                                      
                                        </MenuItem> 
                                    <MenuItem onChange={this.onFileChangeProperty}> 
                                        <label style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}}> 
                                            <input type="file" style={{display:'none',align:'left'}} /> 
                                           {t("bulkUpload")}
                                        </label> 
                                        </MenuItem> 
                                    <a href={"/static/file/propertyBulkUpload.xlsx"} style={{textDecoration:'none', 
                                                                        color:'#3dab35', 
                                                                        fontSize:'small', 
                                                                        fontFamily: "'Open Sans', sans-serif"}} download> 
                                        <MenuItem onClick={this.handleCloseProperty}>{t("downloadSamp")}</MenuItem>     
                                    </a>
                                    </MenuList>
                                </Paper>
                                </ClickAwayListener>
                            )}
                            </Popper>  

                            {/* <Button className="email_link"
                                ref={this.state.anchorRef}
                                aria-controls={this.state.open ? 'menu-list-grow' : undefined}
                                aria-haspopup="true"
                                onClick={this.handleClickArea('bottom')}
                                style={{height:'35px'}}>
                                Bulk Import Area
                                {
                                    this.state.open ?   <ArrowDropUpIcon /> : <ArrowDropDownIcon/> 
                                }
                                
                            </Button>
                            <Popper style={{zIndex:"10"}} open={this.state.open_bulk_area} anchorEl={this.state.anchorEl_bulk_area} placement={this.state.placement_area} transition>
                            {({ TransitionProps }) => (
                                    <ClickAwayListener onClickAway={this.handleClickAwayBulkArea}>
                                <Paper style={{zIndex:1, border:"1px solid #3dab35"}}>
                                    <MenuList>
                                    <MenuItem onChange={this.onFileChangeArea}> 
                                        <label style={{ color:'#3dab35',fontSize:'small',align:'left', fontFamily: "'Open Sans', sans-serif"}}> 
                                            <input type="file" style={{display:'none',align:'left'}} /> 
                                            Bulk Upload Area
                                        </label> 
                                        </MenuItem> 
                                    <a href={AreaBulkUploadFile} style={{textDecoration:'none', 
                                                                        color:'#3dab35', 
                                                                        fontSize:'small', 
                                                                        fontFamily: "'Open Sans', sans-serif"}} download> 
                                        <MenuItem onClick={this.handleCloseArea}>Download Sample</MenuItem>     
                                    </a>
                                    </MenuList>
                                </Paper>
                                </ClickAwayListener>
                            )}
                            </Popper>  
                         */}
                            </div>
                        </div>
                    </div>


                    <div > 
                    {/* {(this.props.loadingData == false) ? <div id="cover-spin"></div>: ''} */}
                    <div className="operator_listing">
                                 <TableContainer component={Paper} style={{paddingLeft:"15px" ,paddingRight:"15px"}}>
                             <Table aria-label="simple table">
                                <TableHead >
                                    <TableRow >
                                        {!!headers&&headers.length == 0? headers:headers }
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                {!!this.props.propertyListing&&this.props.propertyListing.length== 0 && this.props.loadingData ==false? <TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            Loading....</TableRow>: !!this.props.propertyListing&&this.props.propertyListing.length== 0? <TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            No Records Found !!</TableRow>: this.props.loadingData ==false ?<TableRow style={{alignItems:'center', fontWeight:'bold', color:'gray' }}>
                                            Loading....</TableRow> : properties}
                                     

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    </div>
                    {
                        this.props.totalCount &&
                            <TablePagination
                            rowsPerPageOptions={[10,50,100]}
                            colSpan={3}
                            count={this.props.totalCount}
                            component="div"
                            rowsPerPage={this.state.limit}
                            page={this.state.page}
                            SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,
                            }}
                            labelRowsPerPage={t("rowsPerPage")}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                      }
                    <ScheduleDialog open={this.state.openDialog} handleClose = {this.handleDialogClose} propertyId = {this.state.propertyId}></ScheduleDialog>
                    <div className="setFreq">
      <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        // open={true}
        open={this.state.openPop}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>{this.state.editId != ""? t("editProp"):t("addProp")} </span></DialogTitle>
        <DialogContent > 
           <div className="create_ulb_content_outer">
                    <div className="create_ulb_content create_ulb_contentPop">
                <Grid container spacing={1}>

            <Grid item xs={6}>
            <FormControl>
                    <label className="required" htmlFor="ownerName" align="left">{t("ownerName")}</label>
                    <TextField id="ownerName" 
                                variant="outlined" 
                                value={this.state.ownerName} 
                                onChange={this.handleChange} 
                                name="ownerName"   
                                placeholder={t("phownerName")}/>
                    <div style={{fontSize:12,color:"red"}}>{this.state.ownerNameErr}</div> 
                </FormControl>
            </Grid>
            <Grid item xs={6}>
            <FormControl>
                <label className="" htmlFor="buildingName" align="left">{t("propAddress")}</label>
                <TextField id="buildingName" 
                            variant="outlined" 
                            value={this.state.buildingName} 
                            onChange={this.handleChange} 
                            name="buildingName"   
                            placeholder={t("phpropAddress")}/>
                {/* <div style={{fontSize:12,color:"red"}}>{this.state.buildingNameErr}</div>  */}
            </FormControl>
            </Grid>
            <Grid item xs={6}>
            <FormControl>
                    <label className="" htmlFor="houseNo" align="left">{t("HouseNo")}</label>
                    <TextField id="houseNo" 
                                variant="outlined" 
                                value={this.state.houseNo} 
                                onChange={this.handleChange} 
                                name="houseNo"   
                                placeholder={t("Enter house no")}/>
                    <div style={{fontSize:12,color:"red"}}>{this.state.houseNoErr}</div> 
                </FormControl>
            </Grid>
            <Grid item xs={6}>
            <FormControl>
                    <label className="" htmlFor="taxAssessmentNo" align="left">{t("TaxAssessmentNo")}</label>
                    <TextField id="taxAssessmentNo" 
                                variant="outlined" 
                                type='number'
                                value={this.state.taxAssessmentNo} 
                                onChange={this.handleChange} 
                                name="taxAssessmentNo"   
                                placeholder={t("Enter Tax Assessment No")}/>
                    {/* <div style={{fontSize:12,color:"red"}}>{this.state.taxAssessmentNoErr}</div>  */}
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <FormControl>
                    <label className="" htmlFor="usage" align="left">{t("Usage")}</label>
                    <Select value={this.state.usage} onChange={this.handleChange} name="usage">
                        {!!this.state.usageOptions && this.state.usageOptions.map((option) => {
                                return  <MenuItem value={option.Name}>{option.Name}</MenuItem>
                        }
                               
                        )}
                    </Select>

                    {/* <div style={{ fontSize: 12, color: "red" }}>{this.state.ulbNameErr}</div> */}
                </FormControl>
            </Grid>
            {/* {this.state.usage == "Others"? 
              <Grid item xs={6}>
              <FormControl>
                  <label className='required' htmlFor="usageOthers" align="left">{("For Others Usage")}</label>
                  <TextField id="usageOthers"
                      variant="outlined"
                      value={this.state.usageOthers}
                      onChange={this.handleChange}
                      name="usageOthers"
                      placeholder={("Enter Others Usage")} />
              </FormControl>

              </Grid>:""} */}
          
                    <Grid item xs={6}>
                            <FormControl>
                                <label className="" htmlFor="locality" align="left">{t("Locality")}</label>
                                <TextField id="locality"
                                    variant="outlined"
                                    value={this.state.locality}
                                    onChange={this.handleChange}
                                    name="locality"
                                    placeholder={t("Enter Locality")} />
                                {/* <div style={{ fontSize: 12, color: "red" }}>{this.state.localityErr}</div> */}
                            </FormControl>
                        </Grid>
<Grid item xs={6}>
<FormControl>
        <label className="required" htmlFor="phoneNumber" align="left">{t("phoneNumber")}</label>
        <TextField id="phoneNumber" 
                    variant="outlined" 
                    value={this.state.phoneNumber} 
                    onChange={this.handleChange} 
                    name="phoneNumber"   
                    placeholder={t("phPhoneNumber")}/>
        <div style={{fontSize:12,color:"red"}}>{this.state.phoneNumberErr}</div> 
    </FormControl>
</Grid>
<Grid item xs={6}>
<FormControl>
    <label className="required" htmlFor="propType" align="left">{t("propType")}</label>
    <Select value={this.state.propType} onChange={this.handleChange} name="propType" placeholder="Select Property Type">
        {this.state.propertyOptions.map((option) => (
            <MenuItem value={option.id}>{option.name}</MenuItem>
        ))}
    </Select> 
    <div style={{fontSize:12,color:"red"}}>{this.state.propTypeErr}</div>   
</FormControl>
</Grid>
<Grid item xs={6}>
<FormControl>
        <label className="required" htmlFor="containmentType" align="left">{t("containmentType")}</label>
        <Select value={this.state.containmentType} onChange={this.handleChange} name="containmentType">
                    {this.state.containmentOptions.map((option) => (
                        <MenuItem value={option.id}>{option.name}</MenuItem>
                    ))}
                </Select> 
                <div style={{fontSize:12,color:"red"}}>{this.state.containmentTypeErr}</div>             
    </FormControl>
            </Grid>
            <Grid item xs={6}>
            <FormControl>
                    <label className="required" htmlFor="ulbName" align="left">{t("ulbName")}</label>
                    <Select value={this.state.ulbName} onChange={this.handleChange} name="ulbName">
                                {
                                this.state.ulbOptions                           
                                .map((option) =>  
                                    <MenuItem value={option.Id}>{option.Name}</MenuItem> 
                                )}
                            </Select> 

                        <div  style={{fontSize:12,color:"red"}}>{this.state.ulbNameErr}</div>   
                </FormControl>
            </Grid>
                    <Grid item xs={6}>
                    
                    <FormControl>
                        <label htmlFor="zone" align="left">{t("zoneName")}</label>
                        {/* <Select value={this.state.zone} onChange={this.handleChange} name="zone">
                                    {!!this.state.ZoneOptions.length !=0&&this.state.ZoneOptions.map((option) =>{ 
                                        
                                        return(
                                        <MenuItem value={option.ZoneId}>{option.zoneName}</MenuItem>
                                    )})}
                                </Select>  */}
                                 <TextField id="zone" 
                                    variant="outlined" 
                                    value={this.state.zone} 
                                    onChange={this.handleChange} 
                                    name="zone"   
                                    placeholder={t("phWard")}/>
                        <div style={{fontSize:12,color:"red"}}>{this.state.zoneErr}</div> 
                    </FormControl>
                    
                        </Grid>
                
                        <Grid item xs={6}>
            
                                <FormControl>
                        <label htmlFor="wardNo" align="left">{t("wardNo")}</label>
                        <TextField id="wardNo" 
                                    variant="outlined" 
                                    value={this.state.wardNo} 
                                    onChange={this.handleChange} 
                                    name="wardNo"   
                                    placeholder= {t("phWard")}/>
                        <div style={{fontSize:12,color:"red"}}>{this.state.wardNoErr}</div> 
                    </FormControl>

                        </Grid>

                    <Grid item xs={6}>
                                
                    <FormControl>
                        <label className='required' htmlFor="pincode" align="left">{t("pincode")}</label>
                        <TextField id="pincode" 
                                    variant="outlined" 
                                    value={this.state.pincode} 
                                    onChange={this.handleChange} 
                                    name="pincode"   
                                    placeholder= {t("placeholderPincode")}/>
                        <div style={{fontSize:12,color:"red"}}>{this.state.pincodeErr}</div> 
                    </FormControl>

                    </Grid>




                        <Grid item xs={6}>
                                <FormControl variant="outlined" size="small" >
                                     <label>{t("photo")}</label>      <span style={{display:'flex'}}>
                                                    <ImageUploader style={{align:'left'}}withIcon={false}
                                                        type='file'
                                                        singleImage={true} 
                                                        fileContainerStyle = {{color:'#3dab35'}} 
                                                        buttonText= {t("upload")}
                                                        buttonStyles={{backgroundColor:'white', color:'#3dab35',fontSize:'12px', borderRadius:'5px',align:'left',height:'35px',	width:'100%',padding:'0px',marginTop:'1px',marginBottom:'0%', height:"45px"}}
                                                        withLabel={false}
                                                        value={this.state.img}
                                                        onChange={this.handleImage}
                                                        imgExtension={['.jpg', '.png','.jpeg']}
                                                        fileSizeError="Can not edit the Photo!"
                                                        fileTypeError=" is not supported file extension"
                                                        maxFileSize={this.state.editId != ""? 5242880 : 5242880}
                                                       
                                                        buttonClassName="imgButtonEnable"
                                                        />
                                                        {this.state.isLogo &&
                                                         <CancelIcon style={{fontSize:'large',color:'#f51c00'}}  onClick={this.handleRemove} />
                                                         }
                                                        </span>
                                            { this.state.imgErr ? 
                                                   <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"5%",lineHeight:'11px'}}>{this.state.imgErr}</div> 
                                                   : 
                                                   <div>{t("uploadPhoto")}</div>
                                            }
 
                                        </FormControl>
                                </Grid>

                <Grid item xs={6}>
                
                            <FormControl>
                                <label htmlFor="emergency" align="left">{t("emergency")} </label>
                                <Select  value={this.state.emergency } onChange={this.handleChange} name="emergency">
                                                <MenuItem value={"Yes"}>{"Yes"}</MenuItem>
                                                <MenuItem value={"No"}>{"No"}</MenuItem>
                                        </Select> 
                                <div style={{fontSize:12,color:"red"}}>{this.state.emergencyErr}</div>     
                            </FormControl>
                            
                
                </Grid>
                {/* <Grid item xs={6}>

                <FormControl>
                    <label htmlFor="operatorName" align="left">{t("operatorName")} </label>
                    <Select value={this.state.operatorName} onChange={this.handleChange} name="operatorName">
                    {this.state.optOptions&&this.state.optOptions.map((item)=>{
                                return  <MenuItem value={item.operatorId}>{item.name}</MenuItem>

                    })}
                    </Select>
                </FormControl>
                </Grid> */}
                <Grid item xs={6}>
                <FormControl>
                        <label htmlFor="reason" align="left">{t("comment")}</label>
                        <TextField id="reason" 
                                    variant="outlined" 
                                    value={this.state.reason} 
                                    onChange={this.handleChange} 
                                    name="reason"   
                                    placeholder= {t("phComment")}/>
                        <div style={{fontSize:12,color:"red"}}>{this.state.reasonErr}</div> 
                    </FormControl>
                </Grid>
             <Grid item xs={6}>
                
                            <FormControl>
                                <label htmlFor="selectDayMonth" align="left">{t("lastEmptied")} </label>
                                <Select value={this.state.selectDayMonth } onChange={this.handleChange} name="selectDayMonth">
                                                <MenuItem value={'M'}>{t("months")}</MenuItem>
                                                <MenuItem value={'D'}>{t("days")}</MenuItem>
                                        </Select> 
                            </FormControl>
                            
                
                </Grid>

                {
                    this.state.selectDayMonth=='M'?
                    <Grid item xs={6}>
                    <FormControl>
                        <label className="required" htmlFor="months" align="left">{t("months")}</label>
                        <TextField id="months" 
                                    variant="outlined" 
                                    value={this.state.months} 
                                    onChange={this.handleChange} 
                                    name="months"   
                                    placeholder={t("phMonths")}/>
                        {/* <div style={{fontSize:12,color:"red"}}>{this.state.buildingNameErr}</div>  */}
                    </FormControl>
                    </Grid>
                    :this.state.selectDayMonth=='D'? <Grid item xs={6}>
                    <FormControl>
                        <label className="required" htmlFor="days" align="left">{t("days")}</label>
                        <TextField id="days" 
                                    variant="outlined" 
                                    value={this.state.days} 
                                    onChange={this.handleChange} 
                                    name="days"   
                                    placeholder={t("phDays")}/>
                        {/* <div style={{fontSize:12,color:"red"}}>{this.state.buildingNameErr}</div>  */}
                    </FormControl>
                    </Grid>:''
                }
                {/* <Grid item xs={6}>
                            <FormControl>
                                <label htmlFor="isDisableProperty" align="left">Status</label>
                                <Select value={this.state.isDisableProperty} onChange={this.handleStatus} name="isDisableProperty">
                                                <MenuItem value={false} >{"Active"}</MenuItem>
                                                <MenuItem value={true}>{"InActive"}</MenuItem>
                                        </Select> 
                            </FormControl>
                </Grid> */}


                                        <Grid item xs={12}>
                                            <div style={{ height: '30vh', width: '100%', paddingBottom: '15px', position: this.state.position, top: this.state.top, left: this.state.left }}>
                                                <GoogleMapReact
                                                    bootstrapURLKeys={{ key: this.state.maps_key }}
                                                    center={this.state.center}
                                                    zoom={this.state.zoom}
                                                    onClick={this.handleMapClick}
                                                    onChange={this.handleMap}>
                                                    <Marker
                                                        lat={this.state.latitude}
                                                        lng={this.state.longitude}
                                                        name="My Marker"
                                                        color="blue" />
                                                         <div className='current-loct-pro'>
                                                        <MyLocationRoundedIcon className='myloctProp' onClick={() => this.getCurrentLocation()}/>
                                                    </div> 
                                                </GoogleMapReact>
                                            </div>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="latitude" align="left">{t("latitude")}</label>
                                                <OutlinedInput id="latitude"
                                                    variant="outlined"
                                                    disabled
                                                    value={evaluateLocation(this.state.latitude)}
                                                    onChange={this.handleChange}
                                                    name="latitude"
                                                    placeholder={t("EnterLatitude")}
                                                    endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                                                <div style={{ fontSize: 12, color: "red", }}>{this.state.latitudeErr}</div>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl>
                                                <label className="required" htmlFor="longitude" align="left">{t("longitude")}</label>
                                                <OutlinedInput id="longitude"
                                                    variant="outlined"
                                                    disabled
                                                    value={evaluateLocation(this.state.longitude)}
                                                    onChange={this.handleChange}
                                                    name="longitude"
                                                    placeholder={t("EnterLongitude")}
                                                    endAdornment={<InputAdornment><LocationOnOutlinedIcon /></InputAdornment>} />
                                                <div style={{ fontSize: 12, color: "red" }}>{this.state.longitudeErr}</div>
                                            </FormControl>

                                        </Grid>
                                

           
            
   </Grid>
        
                </div>
            </div>    
          
             
        </DialogContent>
        <DialogActions>
            {this.state.openPop === true? 
        <Grid container spacing={1}>
        <Grid item xs={12}>
         <div className="create_ulb_buttons" style={{marginBottom:'10px'}}>
                    <Button className="login_submit" variant="outlined" color="primary" onClick={this.handleClosePop}>{t("cancel")}</Button>
                    <Button className="login_submit" variant="contained" color="primary" onClick={()=>this.handleSubmit()}>{this.state.editId != ""? `${t("saveChange")}`: `${t("save")}`  }</Button>
                </div>
            </Grid>
        </Grid>:""}
        </DialogActions>
    </Dialog>
    </div>
            </div>
        )
    }
}
/**
 * Evaluates lat long for 4 digit precision
 * @param {*} loc - Lat Long for evaluation
 */
 function evaluateLocation(loc) {
    return loc.toString().length > 0 ? parseFloat(loc).toFixed(4) : "";
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        propertyListing:!!state.propertyListing.propertyListing&&state.propertyListing.propertyListing,
        Type : state.propertyListing.propertyTypeList,
        headers:!!state.propertyHeaders.headers&&state.propertyHeaders.headers.concat({header: "Action", accessor: "actionButton", sortable: "false", filter: "true"}),
        propertyListing:state.propertyListing.propertyListing,
        totalCount : state.propertyListing.totalCount,
        loadingData: state.propertyListing.loadingSuccess
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchPropertyHeaders: (payload) => dispatch(actionsCreators.fetchPropertyHeaders(payload)),
        onFetchPropertyListing: (payload,url) => dispatch(actionsCreators.fetchPropertyListing(payload,url)),
        onFetchPropertyBulkImport: (payload,formData,props) => dispatch(actionsCreators.fetchPropertyBulkImport(payload,formData,props)),
        onFetchAreaBulkImport: (payload,formData,props) => dispatch(actionsCreators.fetchAreaBulkImport(payload,formData,props)),
        onPropertyType : ()=>dispatch(actionsCreators.propertyType()),
        onSearchProperty:(payload, url,type)=>dispatch(actionsCreators.searchProperty(payload, url, type)),
        onDeleteProperty : (payload, t)=>dispatch(actionsCreators.deleteProperty(payload, t)),
        exportProperty :(payload) => dispatch(actionsCreators.exportProperty(payload)),
        onEditPropertyData: (formdata, t) => dispatch(actionsCreators.editPropertyData(formdata, t)),
        OnAddPropertySingle: (payload, t)=>dispatch(actionsCreators.AddPropertySingle(payload, t))
    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PropertyListing));